// extracted by mini-css-extract-plugin
export default {"copy":"RemoveMembershipModal_copy__8v1Ao"};